const setBoundary = payload => {
  return {
    type: "boundaryChange",
    payload
  };
};

export default setBoundary;
